import { useContext } from 'react';
import { SnackContext } from '../context/Snackbar';

export default function useSnackbar() {
  const snack = useContext(SnackContext);
  const snackFunc = snack.enqueueSnackbar;

  return [snackFunc];
}
